import React, { useEffect, useState } from 'react';
import * as Styled from './styles';
import { Colors } from '../../../../../values/colors';
import { validateEmail } from '../../../../../utils';

const InputDinamic = ({ isEnabled, canEdit, ...rest }) => {
  const [error, setError] = useState(undefined);

  const onValidate = () => {
    if (rest.type === "email") {
      const isValidEmail = validateEmail(rest.value);
      if (!isValidEmail) {
        setError("Insira um email válido")
      } else setError(undefined);
    }
  }

  useEffect(() => {
    if (!isEnabled) {
      setError(undefined);
    }
  }, [isEnabled])

  return (
    <Styled.Container isVisible={rest.isVisible} isEnabled={isEnabled}>
      <Styled.Line>
        <Styled.ConfigTitle>{rest.title}</Styled.ConfigTitle>

        <div style={{ width: 258 }}>
          <input
            onBlur={onValidate}
            className="border rounded-lg px-3 py-2 w-full focus:outline-none focus:border-blue-500"
            min={rest.type === "number" && rest.name === "dependent_limit" ? 1 : undefined}
            {...rest}
            disabled={!canEdit}
            value={rest.name === "auto_delete" && !rest.value ? "0" : rest.value}
          />
          {!!error && <Styled.Error>{error}</Styled.Error>}
        </div>
      </Styled.Line>

      <Styled.Description>{rest.description}</Styled.Description>
      <hr style={{ height: 1, color: Colors.ultraLightGray2 }} />
    </Styled.Container>
  );
};

export default InputDinamic;
